module.exports = __webpack_public_path__ + "img/Dealer-Draft_logo.bab1e318.png";